import api from "../../../components/api"
import { DefaultLineItemGrouping, GeneralInvoicingSettings, InvoicingSettings, InvoicingSystemSettings } from "./invoicingSettings"

export const getInvoicingSettings = async (): Promise<InvoicingSettings>=> {
  return (await api.get(`/web/invoicing/settings`)).data
}

export const hideApprovedApplication = async (): Promise<void> => {
  await api.post(`/web/invoicing/settings/hide-approved-application`)
}

export const updateInvoicingSystemSettings = async (settings: InvoicingSystemSettings): Promise<void> => {
  await api.post(`/web/invoicing/settings/update-invoicing-system-settings`, settings)
}

export const updateDefaultLineItemGrouping = async (grouping: DefaultLineItemGrouping): Promise<void> => {
  await api.post(`/web/invoicing/settings/update-line-item-grouping`, grouping)
}

export const updateGeneralSettings = async (settings: GeneralInvoicingSettings): Promise<void> => {
  await api.post(`/web/invoicing/settings/update-general-settings`, settings)
}

export const updateDefaultIncludePaymentSummary = async (enabled: boolean): Promise<void> => {
  await api.post(`/web/invoicing/settings/update-default-include-payment-summary`, { enabled })
}